import { useState, useEffect } from 'react';
import { FaPlay, FaExternalLinkAlt } from 'react-icons/fa';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from './components/SEO';

// Import GEY images
import g1 from './assets/GEY/g1.jpeg';
import g2 from './assets/GEY/g2.jpeg';
import g3 from './assets/GEY/g3.jpeg';
import g4 from './assets/GEY/g4.jpeg';
import g5 from './assets/GEY/g5.jpeg';
import g6 from './assets/GEY/g6.jpeg';
import g7 from './assets/GEY/g7.jpeg';
import g8 from './assets/GEY/g8.jpeg';
import g9 from './assets/GEY/g9.jpeg';
import g10 from './assets/GEY/g10.jpeg';
import g11 from './assets/GEY/g11.jpeg';
import g12 from './assets/GEY/g12.jpeg';
import newsPaper from './assets/news_paper.jpeg';
import geyLogo from './assets/gey.png';
import flyerEn from './assets/flyer_en.jpg';
import flyerAr from './assets/flyer_ar.jpg';

const GlobalEgyptianYouth = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    // Define gallery images
    const galleryImages = [
        { id: 1, src: g1, alt: "Global Egyptian Youth artwork 1" },
        { id: 2, src: g2, alt: "Global Egyptian Youth artwork 2" },
        { id: 3, src: g3, alt: "Global Egyptian Youth artwork 3" },
        { id: 4, src: g4, alt: "Global Egyptian Youth artwork 4" },
        { id: 5, src: g5, alt: "Global Egyptian Youth artwork 5" },
        { id: 6, src: g6, alt: "Global Egyptian Youth artwork 6" },
        { id: 7, src: g7, alt: "Global Egyptian Youth artwork 7" },
        { id: 8, src: g8, alt: "Global Egyptian Youth artwork 8" },
        { id: 9, src: g9, alt: "Global Egyptian Youth artwork 9" },
        { id: 10, src: g10, alt: "Global Egyptian Youth artwork 10" },
        { id: 11, src: g11, alt: "Global Egyptian Youth artwork 11" },
        { id: 12, src: g12, alt: "Global Egyptian Youth artwork 12" },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [galleryImages.length]);

    return (
        <>
            <SEO
                title="Global Egyptian Youth"
                description="Celebrating Global Egyptian young artists who turned their dreams to reality. Honored in Italy, France, Germany and Egypt."
                keywords="Global Egyptian Youth, Egyptian artists, art exhibition, Donzi Art Academy, young artists, international recognition"
            />
            <div className="min-h-screen w-full bg-white text-gray-800 font-sans">
                <Navbar />

                {/* Hero Section */}
                <section className="pt-32 pb-12 sm:pb-16 px-4 bg-gradient-to-b from-[#00B7F1]/10 to-white">
                    <div className="container mx-auto justify-center items-center">
                        <div className="flex justify-center items-center mb-4 sm:mb-6">
                            <img
                                src={geyLogo}
                                alt="Global Egyptian Youth"
                                className="w-40 sm:w-52 md:w-60 object-cover"
                            />
                        </div>
                        <h1 className="text-base sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-light mb-3 sm:mb-6 tracking-wide text-center px-2 sm:px-4 leading-tight flex flex-col sm:flex-row justify-center items-center gap-0 sm:gap-x-2 md:gap-x-3 lg:gap-x-4">
                            <div className="font-normal" style={{ color: '#0ea1ef' }}>GLOBAL</div>
                            <div className="font-normal" style={{ color: '#03b9ce' }}>EGYPTIAN</div>
                            <div className="font-normal" style={{ color: '#c4d12c' }}>YOUTH</div>
                        </h1>
                        <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto font-light tracking-wide text-center px-4">
                            Celebrating the journey of talented youth who continue to make us proud every day
                        </p>
                    </div>
                </section>

                {/* Main Content Section */}
                <section className="py-12 sm:py-16 px-4">
                    <div className='flex flex-col lg:flex-row gap-8 lg:gap-12 items-start'>
                        <div className="w-full lg:w-1/2 container mx-auto lg:max-w-4xl">
                            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-700 font-light tracking-wide leading-relaxed">
                                <p>
                                    At Donzi Art Academy, we celebrate Global Egyptian young artists who turned their dreams to reality.
                                </p>
                                <p>
                                    Celebrated in Italy, France, Germany and today, Egypt celebrates and honors their success.
                                </p>
                                <p>
                                    This exhibition is more than a showcase, it is a tribute to the journey of the talented youth of Donzi Art Academy who continue to make us proud every day.
                                </p>
                                <p>
                                    In the presence of distinguished officials and under the support of the Minister of Culture, Dr. Ahmed Hanno, we honor their creativity, passion, and the bright future they represent.
                                </p>
                            </div>
                        </div>

                        <div className="w-full lg:w-1/2 container mx-auto">
                            <div className="relative mb-8 sm:mb-10">
                                <div className="flex overflow-hidden rounded-xl shadow-xl">
                                    <div
                                        className="flex transition-transform duration-500 ease-in-out w-full"
                                        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                                    >
                                        {galleryImages.map((image) => (
                                            <div key={image.id} className="w-full flex-shrink-0">
                                                <div className="aspect-video overflow-hidden">
                                                    <img
                                                        src={image.src}
                                                        alt={image.alt}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Navigation dots */}
                                <div className="flex justify-center mt-4 sm:mt-6 space-x-2">
                                    {galleryImages.map((_, index) => (
                                        <div
                                            key={index}
                                            onClick={() => setCurrentSlide(index)}
                                            className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${currentSlide === index ? 'bg-[#00B7F1] w-4 sm:w-6' : 'bg-gray-300'}`}
                                            aria-label={`Go to slide ${index + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Videos Section */}
                <section className="py-12 sm:py-16 px-4 bg-gray-50">
                    <div className="container mx-auto max-w-5xl">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-light mb-8 sm:mb-12 tracking-wide text-center px-4">
                            MEDIA <span className="font-normal" style={{ color: '#00B7F1' }}>COVERAGE</span>
                        </h2>
                        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
                            <div className="relative">
                                <div className="aspect-video rounded-lg overflow-hidden shadow-lg bg-gray-200">
                                    <iframe
                                        className="w-full h-full"
                                        src="https://www.youtube.com/embed/RrzaiGcg2oE"
                                        title="Global Egyptian Youth Coverage 1"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                            <div className="relative">
                                <div className="aspect-video rounded-lg overflow-hidden shadow-lg bg-gray-200">
                                    <iframe
                                        className="w-full h-full"
                                        src="https://www.youtube.com/embed/YZsVmOgevmA"
                                        title="Global Egyptian Youth Coverage 2"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* News Section */}
                <section className="py-12 sm:py-16 px-4 bg-white">
                    <div className="container mx-auto max-w-6xl">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-light mb-8 sm:mb-12 tracking-wide text-center px-4">
                            NEWS <span className="font-normal" style={{ color: '#C3D83B' }}>HIGHLIGHTS</span>
                        </h2>
                        <div className='flex flex-col lg:flex-row items-center lg:items-start gap-6 lg:gap-4'>
                            {/* News Paper Image */}
                            <div className="mb-6 lg:mb-0 w-full lg:w-1/2 text-center px-2 lg:px-6">
                                <img
                                    src={newsPaper}
                                    alt="News paper coverage"
                                    className="w-2/3 h-auto mx-auto rounded-lg shadow-lg max-w-full"
                                />
                            </div>

                            {/* News Links */}
                            <div className="flex flex-col gap-4 sm:gap-6 w-full lg:w-1/2">
                                <a
                                    href="https://x.com/AsharqNewsEGY/status/1987599828746969582"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group min-h-[140px] sm:h-40 relative overflow-hidden rounded-lg border-2 border-gray-200 hover:border-[#00B7F1] transition-all duration-300 p-4 sm:p-6 bg-gradient-to-br from-white to-gray-50 hover:shadow-xl"
                                >
                                    <div className="flex items-start gap-3 sm:gap-4">
                                        <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#00B7F1] text-white flex items-center justify-center text-lg sm:text-xl">
                                            <FaExternalLinkAlt />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="text-lg sm:text-xl font-light mb-2 tracking-wide" style={{ color: '#00B7F1' }}>
                                                Asharq News Coverage
                                            </h3>
                                            <p className="text-gray-600 font-light tracking-wide text-xs sm:text-sm">
                                                Read about our Global Egyptian Youth exhibition on Asharq News
                                            </p>
                                            <div className="mt-3 sm:mt-4 flex items-center gap-2 text-[#00B7F1] font-light text-xs sm:text-sm">
                                                View Article <FaExternalLinkAlt className="text-xs group-hover:translate-x-1 transition-transform" />
                                            </div>
                                        </div>
                                    </div>
                                </a>

                                <a
                                    href="https://akhbarelyom.com/news/newdetails/4721766/1/-%D8%A8%D8%B9%D9%8A%D9%88%D9%86-%D9%85%D8%B5%D8%B1%D9%8A%D8%A9--%D8%A7%D9%84%D8%A3%D8%B1%D8%AF%D9%86-%D8%AA%D8%B3%D8%AA%D8%B6%D9%8A%D9%81-%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9-%D9%85%D9%86-%D8%A7%D9%84"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group min-h-[140px] sm:h-40 relative overflow-hidden rounded-lg border-2 border-gray-200 hover:border-[#C3D83B] transition-all duration-300 p-4 sm:p-6 bg-gradient-to-br from-white to-gray-50 hover:shadow-xl"
                                >
                                    <div className="flex items-start gap-3 sm:gap-4">
                                        <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#C3D83B] text-black flex items-center justify-center text-lg sm:text-xl">
                                            <FaExternalLinkAlt />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="text-lg sm:text-xl font-light mb-2 tracking-wide" style={{ color: '#C3D83B' }}>
                                                Akhbar El Yom Coverage
                                            </h3>
                                            <p className="text-gray-600 font-light tracking-wide text-xs sm:text-sm">
                                                Egyptian talents honored in Jordan - Read the full story
                                            </p>
                                            <div className="mt-3 sm:mt-4 flex items-center gap-2" style={{ color: '#C3D83B' }}>
                                                <span className="font-light text-xs sm:text-sm">View Article</span>
                                                <FaExternalLinkAlt className="text-xs group-hover:translate-x-1 transition-transform" />
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-12 sm:py-16 px-4 bg-white">
                    <div className="container mx-auto max-w-6xl">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-light mb-8 sm:mb-12 tracking-wide text-center px-4">
                            First <span className="font-normal" style={{ color: '#00B7F1' }}>GEY</span> Exhibition
                        </h2>
                        <div className='flex flex-col lg:flex-row items-center gap-6 lg:gap-4'>
                            <div className="mb-4 lg:mb-0 w-full lg:w-1/2 text-center px-2">
                                <img
                                    src={flyerEn}
                                    alt="First GEY Exhibition"
                                    className="w-full h-auto mx-auto rounded-lg shadow-lg max-w-full"
                                />
                            </div>
                            {/* Date and Location Frame */}
                            <div className="my-4 lg:my-0 w-full lg:w-auto flex justify-center px-2">
                                <div className="bg-gradient-to-br from-[#00B7F1]/10 to-[#C3D83B]/10 border-2 border-[#00B7F1] rounded-lg p-4 sm:p-6 w-full lg:w-auto lg:min-w-[280px]">
                                    <div className="flex flex-col items-center justify-center gap-4 sm:gap-6">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#00B7F1] text-white flex items-center justify-center text-lg sm:text-xl font-light flex-shrink-0">
                                                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <div className="text-xs sm:text-sm font-light text-gray-600 uppercase tracking-wide">Date</div>
                                                <div className="text-base sm:text-lg font-light tracking-wide" style={{ color: '#00B7F1' }}>September 11, 2025</div>
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#C3D83B] text-black flex items-center justify-center text-lg sm:text-xl font-light flex-shrink-0">
                                                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <div className="text-xs sm:text-sm font-light text-gray-600 uppercase tracking-wide">Location</div>
                                                <div className="text-base sm:text-lg font-light tracking-wide" style={{ color: '#C3D83B' }}>Adam Hanein Hall</div>
                                                <div className="text-xs sm:text-sm font-light text-gray-600 tracking-wide">El Hanager Arts Center, Opera House</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4 lg:mb-0 w-full lg:w-1/2 text-center px-2">
                                <img
                                    src={flyerAr}
                                    alt="First GEY Exhibition"
                                    className="w-full h-auto mx-auto rounded-lg shadow-lg max-w-full"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="py-12 sm:py-16 px-4 bg-[#00B7F1] text-white">
                    <div className="container mx-auto text-center">
                        <h2 className="text-2xl sm:text-3xl font-light mb-4 sm:mb-6 tracking-wide px-4">
                            CELEBRATING <span className="font-normal" style={{ color: '#C3D83B' }}>EXCELLENCE</span>
                        </h2>
                        <p className="text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto font-light tracking-wide text-sm sm:text-base px-4">
                            Join us in honoring the achievements of our Global Egyptian Youth artists who continue to inspire and make Egypt proud on the international stage.
                        </p>
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
};

export default GlobalEgyptianYouth;

